import * as React from "react";
import TextField from "@material-ui/core/TextField";
import { useFormContext, Controller } from "react-hook-form";
import { Nullable } from "../../../@typings/typings";

interface SimpleSearcherProps {
  loading: boolean;
  label?: string;
  name: string;
  defaultValue?: Nullable<string | string[]>;
}

export function SimpleSearcher({ label, loading, name, defaultValue = "" }: SimpleSearcherProps) {
  const { control } = useFormContext();
  return (
    <Controller
      data-testid={`simple-searcher-${name}`}
      render={({ field }) => (
        <TextField {...field} label={label} size={"small"} disabled={loading} variant={"outlined"} margin={"dense"} />
      )}
      defaultValue={defaultValue}
      control={control}
      name={name}
    />
  );
}
